
export const LANDING_STATS = {
  ACTIVE_USERS: 3400,
  ACTIVE_USERS_DISPLAY: "3,400+",

  DISCORD_MEMBERS: 700,
  DISCORD_MEMBERS_DISPLAY: "700+",

  SPORTSBOOKS_SCANNED: 30,
  SPORTSBOOKS_SCANNED_DISPLAY: "30+",

  ODDS_REFRESH_SECONDS: 3,
  ODDS_REFRESH_DISPLAY: "<3s",

  DAILY_PLAYS: 100,
  DAILY_PLAYS_DISPLAY: "100+",

  ENTRY_PRICE_DISPLAY: "$59.99/mo",
} as const;

export const TRIAL_LENGTH_DAYS = 5;

export function firstChargeDateLabel(): string {
  const date = new Date();
  date.setDate(date.getDate() + TRIAL_LENGTH_DAYS);
  return new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric" }).format(date);
}

export const TRIAL_TERMS_SHORT = `${TRIAL_LENGTH_DAYS} days free · $0 today, card required`;

export const TRIAL_TERMS_LINE = `${TRIAL_TERMS_SHORT} · From ${LANDING_STATS.ENTRY_PRICE_DISPLAY} after`;

export const FREE_TOOL_TERMS_LINE = "Free with an email. No card.";

export const HOMEPAGE_PLAN_PAGE_VERSION = "main_homepage_plan_v1_20260929";

export const HOME_TRIAL_HREF = "#pricing";
export const OFF_HOME_TRIAL_HREF = "/pricing?redirect_to=/optimizer";

export function signedOutTrialHref(pathname: string | null): string {
  return pathname === "/" ? HOME_TRIAL_HREF : OFF_HOME_TRIAL_HREF;
}

export const DISCORD_URL = "https://discord.gg/D4F25FfaGb";

export const DISCORD_INFLUENCER_URL = "https://discord.gg/D4F25FfaGb";


export const LANDING_ANIMATIONS = {
  fadeInUp: {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 },
  },
  fadeIn: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { duration: 0.5 },
  },
  scaleIn: {
    initial: { opacity: 0, scale: 0.9 },
    animate: { opacity: 1, scale: 1 },
    transition: { duration: 0.5 },
  },
} as const;

export const BLANK_IMAGE_SRC = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
